import { memo, type FC } from 'react';
import { TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { isEmpty } from 'lodash-es';

interface IProps {
  columns: string[];
}
const MetricValueTableHead: FC<IProps> = memo(({ columns }) => {
  return (
    <TableHead sx={{ position: 'relative', zIndex: 3 }}>
      <TableRow sx={{ th: { height: 64, maxHeight: 64, px: 2 } }}>
        <TableCell align="left" sx={{ '&': { width: 280, minWidth: 280, maxWidth: 280 } }}>
          <Typography variant="body2" sx={(t) => ({ fontWeight: t.typography.fontWeightMedium })}>
            Metric
          </Typography>
        </TableCell>
        {!isEmpty(columns) &&
          columns.map((name) => (
            <TableCell key={name} align="left" sx={{ '&': { left: 0, top: 48 } }}>
              <Typography variant="body2" sx={(t) => ({ fontWeight: t.typography.fontWeightMedium })}>
                {name}
              </Typography>
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
});

MetricValueTableHead.displayName = 'MetricValueTableHead';
export default MetricValueTableHead;
